import getLabel from './getLabel';

const getLabels = (options, values = []) => (
  values.map(value => getLabel(options, value)).join(', ')
);

export default getLabels;
